import { render, staticRenderFns } from "./AutomationStatsPreview.vue?vue&type=template&id=00a711c2&scoped=true"
import script from "./AutomationStatsPreview.vue?vue&type=script&lang=js"
export * from "./AutomationStatsPreview.vue?vue&type=script&lang=js"
import style0 from "./AutomationStatsPreview.vue?vue&type=style&index=0&id=00a711c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a711c2",
  null
  
)

export default component.exports